import {commitMutation, graphql} from 'react-relay'
import type {Environment} from 'relay-runtime'

import type {
  AddCommitCommentInput,
  addCommitCommentMutation as addCommitCommentMutationType,
  addCommitCommentMutation$data,
} from './__generated__/addCommitCommentMutation.graphql'

export default function addCommitCommentMutation({
  environment,
  commentsConnectionIds,
  input,
  onCompleted,
  onError,
}: {
  environment: Environment
  commentsConnectionIds: string[]
  input: AddCommitCommentInput
  onCompleted?: (response: addCommitCommentMutation$data) => void
  onError: (error: Error) => void
  threadsConnectionId?: string
}) {
  return commitMutation<addCommitCommentMutationType>(environment, {
    mutation: graphql`
      mutation addCommitCommentMutation($connections: [ID!]!, $input: AddCommitCommentInput!) @raw_response_type {
        addCommitComment(input: $input) {
          comment @appendNode(connections: $connections, edgeTypeName: "CommitCommentEdge") {
            ...useFetchCommitThreadCommitComment
          }
          thread {
            id
          }
        }
      }
    `,
    variables: {input, connections: commentsConnectionIds},
    onCompleted,
    onError,
  })
}
